import { apiPath } from '../_utils/api-version'
import { IDiscounts, IIkoCustomerInfo } from '../_types'
import { request } from './http-client'
import { TParams, INewDiscountParams, IDiscountWithAll } from './types'
import { IDiscountWithProducts } from './types/discounts'

export const discountService = {
  all: (
    params: INewDiscountParams,
    shipper_id?: string,
    useDynamicLanguage = false
  ) =>
    request.get<IDiscountWithAll>(
      apiPath('discount-with-all', useDynamicLanguage),
      {
        params,
        headers: { Shipper: shipper_id },
      }
    ),
  getDiscountWithOrderPrice: (
    params: TParams,
    shipper_id?: string,
    useDynamicLanguage = false
  ) =>
    request.get<IDiscounts>(
      apiPath('discount-with-order-price', useDynamicLanguage),
      {
        params,
        headers: { Shipper: shipper_id },
      }
    ),
  discountWithProductsRequest: (
    params: TParams,
    shipper_id?: string,
    useDynamicLanguage = false
  ) =>
    request.get<IDiscountWithProducts>(
      apiPath('discount-with-products', useDynamicLanguage),
      {
        params,
        headers: { Shipper: shipper_id },
      }
    ),
}

export const getIikoCustomerInfo = (params: any) =>
  request.post<IIkoCustomerInfo>('/v2/crm/iiko-customer-info', undefined, {
    params,
  })

export default discountService
